import UITextInput from 'UIComponents/input/UITextInput';
import { memo } from 'react';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { normalizeValue } from '../utils/normalizeValue';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputEmailV2 = props => {
  const {
    autoFocus,
    disabled,
    inputRef,
    onChange,
    readOnly,
    value
  } = props;
  return /*#__PURE__*/_jsx(UITextInput, Object.assign({}, getTransferrableProps(props), {
    autoFocus: autoFocus,
    disabled: disabled,
    value: normalizeValue(value),
    onChange: onChange,
    readOnly: readOnly,
    inputRef: inputRef,
    type: "email"
  }));
};
export default /*#__PURE__*/memo(PropertyInputEmailV2);